import React from "react";
import { Typography } from "@mui/material";

const SalesUseForm = () => {
  return (
    <>
      <Typography variant="h5" gutterBottom>
        Sales & Use Form
      </Typography>
      <Typography>Manage your sales & use tax forms here.</Typography>
    </>
  );
};

export default SalesUseForm;
